import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AppService } from '../../services/app/app.service';
import { PipesModule } from 'app/pipes/pipes.module';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  standalone: true,
  imports: [PipesModule, MatCardModule]
})
export class CookiesComponent implements OnInit {

  constructor(private appService: AppService) { }

  ngOnInit(): void {
    this.appService.setMeta(
      'Cookies - ' + this.appService.getTraduccion('meta.title'), 
      this.appService.getTraduccion('meta.description'), 
      this.appService.getTraduccion('meta.keywords')
    );
  }

}
